import { create } from 'zustand';
import { mensajeDeError } from '@/lib/api/mensaje-de-error';
import { comerciaService } from '../services/comercia-service';
import type { ImportacionDeComercia, UltimaRuta } from '../types/comercia.types';

/**
 * La importación que se está armando, compartida por los tres pasos.
 *
 * Una sola copia para todas las pantallas de Comercia: el costo acumulado de
 * arriba, la tabla de Productos, la carga y la ruta leen lo mismo, y cada
 * escritura del servidor devuelve la importación ya actualizada, que se guarda
 * acá. Así no hay dos pantallas mostrando números distintos de la misma cosa.
 */
interface EstadoDeLaImportacion {
  importacion: ImportacionDeComercia | null;
  ultima: UltimaRuta | null;
  /** `true` hasta que llegó la primera respuesta. */
  cargando: boolean;
  error: string | null;
  cargar: () => Promise<void>;
  /** Guarda la importación que devolvió una escritura. */
  aplicar: (r: { importacion: ImportacionDeComercia | null }) => void;
}

export const useImportacion = create<EstadoDeLaImportacion>((set) => ({
  importacion: null,
  ultima: null,
  cargando: true,
  error: null,
  cargar: async () => {
    try {
      const r = await comerciaService.actual();
      set({ importacion: r.importacion, ultima: r.ultima, cargando: false, error: null });
    } catch (e) {
      set({
        cargando: false,
        error: mensajeDeError(e, 'No se pudo cargar tu importación. Vuelve a intentar.'),
      });
    }
  },
  aplicar: (r) => set({ importacion: r.importacion, error: null }),
}));
